import { Namespace, TFunction } from 'react-i18next';
import * as Yup from 'yup';

import { AddressProvider } from '@app/models/wms';

export const AddressValidationSchema = (t: TFunction<Namespace<'validation'>>) =>
  Yup.object({
    provider: Yup.mixed<AddressProvider>().oneOf(Object.values(AddressProvider)).required(t('required')),
    provider_address_uid: Yup.string().required(t('required')),
    street_name: Yup.string().defined(t('required')),
    street_number: Yup.string().nullable().default(null),
    place_name: Yup.string().nullable().default(null),
  })
    .transform((value) => (value && Object.values(value).every((field) => field === undefined) ? undefined : value))
    .default(undefined);
